// extracted by mini-css-extract-plugin
module.exports = {"teamImg":"about_teamImg__1ddYJ","iconSize":"about_iconSize__DbH6b"};